import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import { adminAPI } from '../../services/api';

/**
 * Admin: Contacts Export. Downloads an Excel (.xlsx) of Name + Phone for one
 * audience at a time — Customers, Restaurants, or Delivery Partners. Fetched
 * through the authenticated API and saved client-side.
 */
const AUDIENCES = [
  { type: 'users', title: '👤 Customers', desc: 'All customer accounts (name + phone).', color: '#2563EB' },
  { type: 'restaurants', title: '🏪 Restaurants', desc: 'Restaurant name + contact phone.', color: '#16A34A' },
  { type: 'delivery', title: '🛵 Delivery Partners', desc: 'All delivery partners (name + phone).', color: '#D97706' },
];

export default function ContactsExport() {
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState('');

  const download = async (type, title) => {
    setBusy(type); setMsg('');
    try {
      const res = await adminAPI.exportContacts(type);
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const day = new Date().toISOString().slice(0, 10);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `foodwinc-${type === 'delivery' ? 'delivery-partners' : type}-${day}.xlsx`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(a.href);
      setMsg(`${title} downloaded ✓`);
    } catch (e) {
      setMsg(e.response?.data?.message || 'Export failed');
    } finally { setBusy(''); }
  };

  return (
    <>
      <Navbar />
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '24px 16px 60px' }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>📇 Contacts Export</h1>
        <p style={{ color: '#6b7280', marginBottom: 22 }}>
          Download an Excel (.xlsx) list of <b>name &amp; phone number</b> for each group, separately.
        </p>

        <div style={{ display: 'grid', gap: 14 }}>
          {AUDIENCES.map((a) => (
            <div key={a.type} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 20, display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 17, fontWeight: 700, color: '#0F172A' }}>{a.title}</div>
                <div style={{ fontSize: 13, color: '#6b7280', marginTop: 2 }}>{a.desc}</div>
              </div>
              <button
                onClick={() => download(a.type, a.title)}
                disabled={!!busy}
                style={{ padding: '10px 20px', background: busy === a.type ? '#9ca3af' : a.color, color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: busy ? 'default' : 'pointer', whiteSpace: 'nowrap' }}
              >
                {busy === a.type ? 'Preparing…' : '⬇ Download Excel'}
              </button>
            </div>
          ))}
        </div>

        {msg && <div style={{ marginTop: 16, fontSize: 13, fontWeight: 600, color: msg.includes('✓') ? '#166534' : '#b91c1c' }}>{msg}</div>}
        <p style={{ fontSize: 12, color: '#9ca3af', marginTop: 18, lineHeight: 1.6 }}>
          Each file has two columns — <b>Name</b> and <b>Phone</b> — one row per contact. Phone is stored as text so Excel keeps it verbatim.
        </p>
      </div>
    </>
  );
}
